var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotProcessed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.1 20.7c-.1 0-.4 0-.5-.1L13 13.9l-6.6 6.6c-.3.3-.7.3-1 0s-.3-.7 0-1l6.6-6.6-6.6-6.5c-.1-.3-.1-.7 0-1s.7-.3 1 0L13 12l6.6-6.6c.3-.3.7-.3 1 0s.3.7 0 1L14 13l6.6 6.6c.3.3.3.7 0 1-.1.1-.4.1-.5.1"
})));
export default SvgNotProcessed;